class DateReq {
  constructor() {
    this.dateFrom = null;
    this.dateTo = null;
  }
}

export default DateReq;